export default "__VITE_ASSET__C7sCXl4g__"